import {
  Sheet,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetContent,
} from '@/components/ui/sheet';
import CalendarBookingForm from '@/components/elements/forms/calendarBookingForm';
import { EventClickArg } from '@fullcalendar/core/index.js';
import { useState } from 'react';
import DeleteCalendarBookingAlert from './deleteCalendarBooking';
import { Button } from '@/components/ui/button';

interface EditCalendarBookingProps {
  eventSelected?: EventClickArg;
  show: boolean;
  setShow: (open: boolean) => void;
}

export default function EditCalendarBooking({
  ...props
}: EditCalendarBookingProps) {
  const [showDelete, setShowDelete] = useState<boolean>(false);

  return (
    <Sheet open={props.show} onOpenChange={props.setShow}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Edit Booking</SheetTitle>
          <SheetDescription>Edit the booking details below</SheetDescription>
        </SheetHeader>
        <CalendarBookingForm
          parentShow={props.setShow}
          bookingId={props.eventSelected?.event.id}
          date={props.eventSelected?.event.start}
          bookingStart={props.eventSelected?.event.start}
          bookingEnd={props.eventSelected?.event?.end}
          comment={props.eventSelected?.event.extendedProps.comment}
          userId={props.eventSelected?.event.extendedProps.user}
        />
        {props.eventSelected?.event.id ? (
          <div>
            <br />
            <div className='flex gap-3 py-3'>
              <Button variant='destructive' onClick={() => setShowDelete(true)}>
                Delete Booking
              </Button>
              <DeleteCalendarBookingAlert
                id={props.eventSelected?.event.id}
                show={showDelete}
                setShow={setShowDelete}
                parentSetShow={props.setShow}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </SheetContent>
    </Sheet>
  );
}
